module.exports = __webpack_public_path__ + "static/media/rebirth_19.190bcb18.jpg";